export const dataOptionInput = [
  {
    value: 'OrderId',
    label: ' Mã đơn hàng'
  },
  {
    value: 'CustomerId',
    label: 'Mã khách hàng'
  }
];

export const dataOptionInputV1 = [
  {
    value: 'invoiceNo',
    label: 'Số Hóa Đơn'
  },
  {
    value: 'orderCode',
    label: 'Mã đơn hàng'
  },
  {
    value: 'customerCode',
    label: 'Mã khách hàng'
  }
];

export const dataOptionTransaction = [
  {
    value: 'ProductCode',
    label: 'Mã sản phẩm'
  },
  {
    value: 'PhoneOrSerial',
    label: 'Serial -SĐT'
  }
];

export const dataOptionInvoice = [
  {
    value: 'AD',
    label: ' Ánh Dương'
  },
  {
    value: 'BM',
    label: 'Bình Minh'
  }
];

export const dataSearchWhat = [
  {
    value: 1,
    label: 'Mã đơn hàng'
  },
  {
    value: 2,
    label: 'Khách hàng'
  },
  {
    value: 3,
    label: 'Serial - Biển số'
  },
  {
    value: 4,
    label: 'Sim thiết bị'
  },
  {
    value: 0,
    label: 'Tất cả'
  }
];

export const dataProductTransactionV1 = [
  {
    value: 1,
    label: 'Mã đơn hàng'
  },
  {
    value: 2,
    label: 'Mã sản phẩm'
  },
  {
    value: 3,
    label: 'Biển số xe'
  }
];

export const dataProductTransactionV2 = [
  { value: 1, label: 'Serial' },
  { value: 2, label: 'SĐT' },
  { value: 3, label: 'Mã đơn hàng' }
  // { value: 4, label: 'Biển số xe' },
  // { value: 5, label: 'Mã hoặc tên sản phẩm' }
];

export const dataSearchWhatCustomer = [
  {
    value: 1,
    label: 'Mã khách hàng'
  },
  {
    value: 2,
    label: 'Tên khách hàng'
  },
  {
    value: 3,
    label: 'Địa chỉ'
  },
  {
    value: 4,
    label: 'Email'
  },
  {
    value: 5,
    label: 'Số điện thoại'
  }
];

export const dataOptionInputTime = [
  {
    value: 1,
    label: 'TG Hoàn tất'
  },
  {
    value: 0,
    label: 'TG Tạo'
  }
];

export const dataTypeBranch = [
  {
    value: 0,
    label: 'CN thực hiện'
  },
  {
    value: 1,
    label: 'CN tạo đơn'
  }
];

export const dataOptionAfterComplete = [
  {
    value: 1,
    label: 'TG Hoàn tất'
  },
  {
    value: 0,
    label: 'TG Tạo đơn'
  },
  {
    value: 3,
    label: 'TG Hẹn lắp'
  },
  {
    value: 2,
    label: 'TG Sửa sau hoàn tất'
  }
];

export const dataOptionTimeRequest = [
  {
    value: 0,
    label: 'TG Tạo đơn'
  },
  {
    value: 1,
    label: 'TG Hoàn tất'
  },
  {
    value: 2,
    label: 'TG Sửa sau hoàn tất'
  },
  {
    value: 3,
    label: 'TG Hẹn lắp'
  },
  {
    value: 4,
    label: 'TG Cập nhật'
  }
];

export const dataProductTransaction = [
  {
    value: 1,
    label: 'TG Nhận'
  },
  {
    value: 2,
    label: 'TG Lắp'
  }
];

export const dataOptionCompanyName = [
  {
    value: 'AnhDuong',
    label: 'Ánh Dương'
  },
  {
    value: 'BinhMinh',
    label: 'Bình Minh'
  }
];

export const dataHTTT = [
  {
    value: 'Tiền mặt',
    label: 'Tiền mặt'
  },
  {
    value: 'Chuyển khoản',
    label: 'Chuyển khoản'
  },
  {
    value: 'Nợ',
    label: 'Nợ'
  }
];

export const dataBlock = [
  {
    value: 0,
    label: 'Khóa'
  },
  {
    value: 1,
    label: 'Không khóa'
  }
];

export const dataOperateCollected = [
  // {
  //   value: -1,
  //   label: 'Tất cả'
  // },
  {
    value: 0,
    label: 'Chưa thu tiền'
  },
  {
    value: 1,
    label: 'Đã thu tiền'
  }
];

export const dataAccountantCollected = [
  // {
  //   value: -1,
  //   label: 'Tất cả'
  // },
  {
    value: 0,
    label: 'Chưa thu tiền'
  },
  {
    value: 1,
    label: 'Đã thu tiền'
  }
];

export const dataCoopType = [
  {
    value: 1,
    label: 'Khách lẻ'
  },
  {
    value: 2,
    label: 'Công ty'
  },
  {
    value: 3,
    label: 'Đại lý'
  },
  {
    value: 4,
    label: 'HTX'
  },
  {
    value: 5,
    label: 'Showroom'
  },
  {
    value: 6,
    label: 'Cộng tác viên'
  }
];

export const dataCSKHType = [
  {
    value: 'New',
    label: 'Mới'
  },
  {
    value: 'Received',
    label: 'Đã xem'
  },
  {
    value: 'Processing',
    label: 'Đang xử lý'
  },
  {
    value: 'Completed',
    label: 'Hoàn tất'
  },
  {
    value: 'Canceled',
    label: 'Hủy'
  }
];

export const dataCSKHServer = [
  {
    value: 0,
    label: 'Low'
  },
  {
    value: 1,
    label: 'Medium'
  },
  {
    value: 2,
    label: 'High'
  },
  {
    value: 3,
    label: 'Urgent'
  }
];

export const dataCSKHActor = [
  {
    value: 'System',
    label: 'Hệ thống'
  },
  {
    value: 'Customer',
    label: 'Khách'
  },
  {
    value: 'Staff',
    label: 'Nhân viên'
  }
];

export const dataCSKHAction = [
  {
    value: 'Create',
    label: 'Tạo'
  },
  {
    value: 'Receive',
    label: 'Đã nhận'
  },
  {
    value: 'Update',
    label: 'Cập nhật'
  },
  {
    value: 'Process',
    label: 'Đang thực hiện'
  },
  {
    value: 'Postpone',
    label: 'Hẹn lại'
  },
  {
    value: 'Complete',
    label: 'Hoàn thành'
  },
  {
    value: 'Cancel',
    label: 'Hủy'
  },
  {
    value: 'NoteAfterComplete',
    label: 'Ghi chú sau hoàn tất'
  }
];

// Kiểu tìm của API SupportTicket/GetForInner (backend xác nhận 23/10/2026), chỉ trang Quản lý phiếu dùng:
// -1 tất cả · 1 mã phiếu · 2 SĐT / tên / userName KH · 3 biển số xe
export const dataCSKHSearchOption = [
  {
    value: -1,
    label: 'Tất cả'
  },
  {
    value: 1,
    label: 'Mã phiếu'
  },
  {
    value: 2,
    label: 'SĐT / Tên KH'
  },
  {
    value: 3,
    label: 'Biển số xe'
  }
];
